import { useTranslation } from "react-i18next";
import { FileText, X } from "lucide-react";
import { Button } from "@tabipla/ui";

interface DraftBannerProps {
  onRestore: () => void;
  onDiscard: () => void;
}

/**
 * Banner shown when a saved draft is available.
 * Offers options to restore or discard the draft.
 */
export function DraftBanner({ onRestore, onDiscard }: DraftBannerProps) {
  const { t } = useTranslation();

  return (
    <div className="mb-4 flex items-center justify-between gap-3 rounded-lg border border-primary/20 bg-primary/5 p-3">
      <div className="flex items-center gap-2 text-sm">
        <FileText className="h-4 w-4 text-primary" />
        <span>{t("draft.available")}</span>
      </div>
      <div className="flex gap-2">
        <Button size="sm" variant="ghost" onClick={onDiscard} className="h-7 px-2 text-xs">
          <X className="mr-1 h-3 w-3" />
          {t("draft.discard")}
        </Button>
        <Button size="sm" onClick={onRestore} className="h-7 px-2 text-xs">
          {t("draft.restore")}
        </Button>
      </div>
    </div>
  );
}
